<div class="header">
  <div class="header__info">
    <a class="header__logo_wrapper" [routerLink]="['/', companyId, 'models']">
      <svg-icon [src]="skyfishLogo" svgClass="header__logo"></svg-icon>
      <span class="header__version">v.{{ version }}</span>
    </a>
  </div>

  <div class="header__settings">
    <ng-container *ngIf="isAuth">
      <button
        type="button"
        [nbContextMenu]="items"
        nbContextMenuTag="profile-menu"
        type="button"
        class="header__user header__opacity_button"
      >
        <span class="header__name">{{ user.firstName }} {{ user.lastName }}</span>
        <span class="header__title">{{ roles }}</span>
      </button>

      <div class="header__divider"></div>

      <app-company
        [logo]="companyLogo"
        [isCompanyMenuAvailable]="isUserInOtherCompanies() || hasAccessToAdminPanel()"
        [credits]="credits"
        (companyMenuToggle)="toggleMenu()"
        (creditsRequestDropdownToggle)="toggleCreditsRequestDropdown()"
      ></app-company>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="showDropDownMenu">
  <app-company-selection-drop-down></app-company-selection-drop-down>
</ng-container>

<ng-container *ngIf="showCreditsRequestDropdown">
  <app-credits-request-dropdown [credits]="credits"></app-credits-request-dropdown>
</ng-container>
